import React from "react";

import "./HomeScreen.css";

import CarouselScreen from "../CarouselScreen/CarouselScreen";
import GoogleMapScreen from "../GoogleMapScreen/GoogleMapScreen";
import IntroductionScreen from "../IntroductionScreen/IntroductionScreen";
import ProgramScreen from "../SliderScreen/ProgramScreen";

const HomeScreen = () => {
  return (
    <div>
      <CarouselScreen />
      <IntroductionScreen />
      <ProgramScreen />

      <GoogleMapScreen />
    </div>
  );
};

export default HomeScreen;
